module.exports = __webpack_public_path__ + "static/media/login_logo1.71646143.svg";